import React from 'react'
import Route from 'react-router/lib/Route'
import IndexRoute from 'react-router/lib/IndexRoute'

import App from 'containers/App'
import Login from 'containers/Auth/Login'
import Logout from 'containers/Auth/Logout'

import Admin from 'containers/Admin'
import Account from 'containers/Account'

import Admission from 'containers/Admission'

import Advising from 'containers/Advising'
import AdvisingDefault from 'containers/Advising/default'
import AdvisingNew from 'containers/Advising/new'
import AdvisingShow from 'containers/Advising/show'
import AdvisingShowDefault from 'containers/Advising/show-default'
import AdvisingEdit from 'containers/Advising/edit'

import Students from 'containers/Students'
import StudentsDefault from 'containers/Students/default'
import StudentsNew from 'containers/Students/new'
import StudentsShow from 'containers/Students/show'
import StudentsProfile from 'containers/Students/profile'
import StudentsEdit from 'containers/Students/edit'

import Billing from 'containers/Billing'
import BillingDefault from 'containers/Billing/default'
import BillingShow from 'containers/Billing/show'

import Ledger from 'containers/Ledger'
import LedgerDefault from 'containers/Ledger/default'
import LedgerShow from 'containers/Ledger/show'

import Print from 'containers/Print'
import PrintBilling from 'containers/Print/Billing'
import PrintLedger from 'containers/Print/Ledger'

import auth from 'containers/Admin/authentication'

export default function createRoutes(store) {
  return (
    <Route component={App}>
      <Route path="/login" component={Login} />
      <Route path="logout" component={Logout} onEnter={Logout.onEnter(store)} />
      <Route path="/" component={Admin} onEnter={auth(store)}>
        <Route path="account" component={Account} />
        <Route path="admission" component={Admission} />
        <Route path="advising" component={Advising} onEnter={Advising.onEnter(store)}>
          <IndexRoute component={AdvisingDefault} />
          <Route path="new" component={AdvisingNew} onEnter={AdvisingNew.onEnter(store)} />
          <Route path=":studentID" component={AdvisingShow} onEnter={AdvisingShow.onEnter(store)}>
            <IndexRoute component={AdvisingShowDefault} />
            <Route path="edit" component={AdvisingEdit} />
          </Route>
        </Route>
        <Route path="students" component={Students}>
          <IndexRoute component={StudentsDefault} />
          <Route path="new" component={StudentsNew} />
          <Route path=":studentID" component={StudentsShow} onEnter={StudentsShow.onEnter(store)}>
            <IndexRoute component={StudentsProfile} />
            <Route path="edit" component={StudentsEdit} />
          </Route>
        </Route>
        <Route path="billing" component={Billing} onEnter={Billing.onEnter(store)}>
          <IndexRoute component={BillingDefault} />
          <Route path=":studentID" component={BillingShow} onEnter={BillingShow.onEnter(store)} />
        </Route>
        <Route path="ledger" component={Ledger}>
          <IndexRoute component={LedgerDefault} />
          <Route path=":studentID" component={LedgerShow} onEnter={LedgerShow.onEnter(store)} />
        </Route>
      </Route>
      <Route path="print" component={Print}>
        <Route path="billing/:studentID" component={PrintBilling} />
        <Route path="ledger/:studentID" component={PrintLedger} />
      </Route>
    </Route>
  )
}



// WEBPACK FOOTER //
// ./src/routes.js